import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { DepartmentService } from '../../services/jrni/department.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../../services/jrni/api.service';
import { environment } from 'apps/dorsetcouncil-hwrc-booking-service/src/environments/environment.prod';
import { DatastoreService } from '../../services/datastore.service';

@Component({
  selector: 'app-privacy-statement',
  templateUrl: './privacy-statement.component.html',
  styleUrl: './privacy-statement.component.scss',
})
export class PrivacyStatementComponent implements OnInit {
  statement = '';
  faChevronLeft = faChevronLeft;

  constructor(
    private apiService: ApiService,
    private location: Location,
    private spinner: NgxSpinnerService,
    public datastoreService: DatastoreService,
  ) { }

  async ngOnInit() {
    this.scrollToTop();
  }

  routerGoBack() {
    this.location.back()
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

}
